export const MINIMUM_ORDER_TOTAL = 400;
export const MINIMUM_ORDER_MESSAGE = 'Minimum quantity not met in current order';
export const MINIMUM_ORDER_GUIDANCE = 'Your order total must be greater than Rs. 400. Please add more items.';

export const meetsMinimumOrderTotal = (total) => {
    const amount = Number(total);
    return Number.isFinite(amount) && Math.round(amount * 100) > MINIMUM_ORDER_TOTAL * 100;
};
